// src/config/config.mjs
export const API_DJANGO_URL  = process.env.REACT_APP_API_DJANGO_URL;
export const API_BACKEND_URL = process.env.REACT_APP_API_BACKEND_URL;
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'robyflow Hub';

console.log(API_BACKEND_URL)
console.log(API_DJANGO_URL)

if (!API_DJANGO_URL || !API_BACKEND_URL) {
  throw new Error(
    "Bitte definiere API_DJANGO_URL und API_BACKEND_URL in der Root-.env"
  );
}
